import { module } from 'modujs';
import Cookies from 'js-cookie';

export default class extends module {
    constructor(m) {
        super(m);
        this.el.addEventListener( 'response', response => {
            if( response.detail.success ){
                document.querySelector( '[data-module-modal="registration-complete"] [data-modal="open"]').click();
                this.el.closest( '.group[data-steps]' ).classList.remove( 'step-1' );
            }
        });

        [...this.el.querySelectorAll("[data-expertise-checkbox]")].forEach( checkbox => {
            checkbox.addEventListener( 'click', this.getExpertises.bind( this ) );
        });



    }


    getExpertises(){
        let expertises = [];
        [...this.el.querySelectorAll("[data-expertise-checkbox]:checked")].forEach( checkbox => {
            expertises.push( checkbox.value );
        });
        Cookies.set('registration-expertise', expertises.join( '-') );
        return expertises;
    }

    addQueryParameter(url, paramName, paramValue) {
        const urlObj = new URL(url);
        const params = new URLSearchParams(urlObj.search);
        params.delete( paramName );
        if( paramValue !== '' ){
            params.append( paramName, paramValue);
        }
        urlObj.search = params.toString();
        return urlObj.toString();
    }

    init() {}
    destroy(){}
}
